<template>
  <v-dialog :value="filterForm.modalType === 'schoolLevel'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển nhóm ngành
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển nhóm ngành"
              >
                <v-autocomplete
                  v-model="schoolLevelId"
                  :items="cloneschoolLevelList"
                  item-text="name"
                  item-value="id"
                  label
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    schoolLevelList: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      schoolLevelId: '',
      cloneschoolLevelList: []
    };
  },
  created() {
    this.cloneschoolLevelList = _.cloneDeep(this.schoolLevelList);
    this.cloneschoolLevelList.shift();
  },
  methods: {
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.statusId = '';
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(contact => contact.checkbox);
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text:
            'Vui lòng chọn khách hàng và lựa chọn nhóm ngành cần thay đổi !!!'
        });
      }

      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        schoolLevelId: this.schoolLevelId,
      }));
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactSchoolLevel(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.$swal({
        title: 'Chuyển nhóm ngành thành công!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
        Bus.$emit('contact-status-list');
      });
    }
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
</style>
